import { useQuery } from "@tanstack/react-query";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { adminApi } from "./api";
import { AdminShell } from "./components/AdminShell";
import { DashboardPage } from "./pages/DashboardPage";
import { FlowListPage } from "./pages/FlowListPage";
import { GenesisPage } from "./pages/GenesisPage";
import { LiquidityPage } from "./pages/LiquidityPage";
import { LoginPage } from "./pages/LoginPage";
import { NodeSearchPage } from "./pages/NodeSearchPage";
import { SettlementPage } from "./pages/SettlementPage";
import { TransferPage } from "./pages/TransferPage";
import { MarketOperationsPage } from "./pages/MarketOperationsPage";
import { ReferralNetworkPage } from "./pages/ReferralNetworkPage";
import { DailyRewardStatisticsPage } from "./pages/DailyRewardStatisticsPage";

function ProtectedLayout() {
  const location = useLocation();
  const session = useQuery({
    queryKey: ["admin-session"],
    queryFn: () => adminApi<{ authenticated: boolean }>("/auth/session"),
    retry: false
  });
  if (session.isLoading) return <div className="console-loader"><span>OCS</span><p>验证管理员会话…</p></div>;
  if (!session.data?.authenticated) return <Navigate to="/login" state={{ from: location }} replace />;
  return <AdminShell />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="deposits" element={<FlowListPage kind="deposits" />} />
        <Route path="treasury-flows" element={<FlowListPage kind="treasury" />} />
        <Route path="withdrawals" element={<FlowListPage kind="withdrawals" />} />
        <Route path="daily-rewards" element={<DailyRewardStatisticsPage />} />
        <Route path="nodes" element={<NodeSearchPage />} />
        <Route path="referral-network" element={<ReferralNetworkPage />} />
        <Route path="liquidity" element={<LiquidityPage />} />
        <Route path="settlements" element={<SettlementPage />} />
        <Route path="transfers" element={<TransferPage />} />
        <Route path="genesis" element={<GenesisPage />} />
        <Route path="market-operations" element={<MarketOperationsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
